import React from "react";
import { Link } from "react-router-dom";
import SEO from "../SEO";
import { business } from "../../seo/business";

const NotFound = () => (
  <main className="center-container fade-in" id="main-content">
    <SEO
      title="Page Not Found"
      description="The page you're looking for doesn't exist. Visit Benson Dental Studio in Bensonhurst, Brooklyn."
      noindex
    />
    <div className="not-found">
      <h1>Page Not Found</h1>
      <p>Sorry, we couldn't find that page.</p>
      <p>
        <Link to="/">Home</Link> · <Link to="/services">Dental Services</Link> ·{" "}
        <Link to="/contact">Contact Us</Link> ·{" "}
        <a href={`tel:${business.phone}`}>{business.phone}</a>
      </p>
    </div>
  </main>
);

export default NotFound;
